'use client';
var classes = { "container": "m_925c2d2c", "root": "m_2415a157" };

export { classes as default };
//# sourceMappingURL=SimpleGrid.module.css.mjs.map